import React, { useRef, useState,useEffect } from 'react';
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { Captcha ,formatMoneda} from '../util/varios'
import axios from 'axios';


export function Mensaje(props) {
    const btnAceptar = useRef();
    const [icono, setIcono] = useState('');

    function icon(icono) {
        
        switch (icono) {
            case 'exito':
                setIcono(<i className='fas fa-check-double fa-5x text-center text-success'></i>);
                break;
            case 'error':
                setIcono(<i className='fas fa-exclamation-triangle fa-5x text-center text-danger'></i>);
                break;
            case 'informacion':
                setIcono(<i className='fas fa-exclamation fa-5x text-center text-info'></i>);
                break;
            default:
                break;
        }

    }
    return (

        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            animation={false}
            keyboard={false}
            show={props.mensaje.mostrar}
            onShow={() => { icon(props.mensaje.icono); btnAceptar.current.focus(); }}
        >
            <Modal.Body style={{ backgroundColor: "#ffffff" }} >
                <div className='row col-12'>
                    <div className='col-12 p-2'>
                        <h2 style={{ textAlign: 'center', fontWeight: 'bold', color: "#595959"}}>{props.mensaje.titulo}</h2>
                    </div>
                    <div className='col-12 p-2 text-center'>
                        {icono}
                    </div>
                    <div className='col-12 p-2'>
                        <p style={{ textAlign: 'center'}}>{props.mensaje.texto}</p>
                    </div>
                    <div className='col-12 p-2'>
                        <button className='btn btn-sm rounded-pill btn-primary col-3' style={{ marginLeft: '38%' }} ref={btnAceptar} onClick={props.onHide}>Aceptar</button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export const MensajeSiNo = (props) => {
    const btnSi = useRef();
    const btnNo = useRef();
    const [icono, setIcono] = useState('');

    function icon(icono) {
        
        switch (icono) {
            case 'exito':
                setIcono(<i className='fas fa-check-double fa-5x text-center text-success'></i>);
                break;
            case 'error':
                setIcono(<i className='fas fa-exclamation-triangle fa-5x text-center text-danger'></i>);
                break;
            case 'informacion':
                setIcono(<i className='fas fa-exclamation fa-5x text-center text-info'></i>);
                break;
                case 'confirmacion':
                    setIcono(<i className='fas fa-question fa-5x text-center text-warning'></i>);
                    break;
            default:
                break;
        }

    }
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            animation={false}
            keyboard={false}
            show={props.mensaje.mostrar}
            onShow={() => { icon(props.mensaje.icono); btnSi.current.focus(); }}
        >
            <Modal.Body style={{ backgroundColor: "#ffffff" }} >
                <div className='row col-12 mx-auto'>
                    <div className='col-12 p-2'>
                        <h2 style={{ textAlign: 'center', fontWeight: 'bold', color: "#595959"}}>{props.mensaje.titulo}</h2>
                    </div>
                    <div className='col-12 p-2 text-center'>
                        {icono}
                    </div>
                    <div className='col-12 p-2'>
                        <p style={{ textAlign: 'center'}}>{props.mensaje.texto}</p>
                    </div>
                    <div className='row col-12 p-2 d-flex justify-content-center mx-auto'>
                        <button className='btn btn-sm rounded-pill btn-success col-5 mx-2' ref={btnSi} onClick={props.onHideSi}>Si</button>
                        <button className='btn btn-sm rounded-pill btn-danger col-5 mx-2' ref={btnNo} onClick={props.onHideNo}>No</button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}


export const MensajeCapcha = (props) => {
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtValor = useRef();

    const handleInputChange = (event) => {

        if (event.which === 13) {
            if (event.target.value.trim() === '') {
                txtValor.current.focus();
            } else {
                btnAcepta.current.focus();
            }


        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    }
    return (
        <Modal
            {...props}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => { Captcha(); txtValor.current.focus() }}
        >
            <Modal.Header>
                <Modal.Title><i>Confirmación</i></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <h4>Imagen de Seguridad:</h4>
                    <h4>Introduzca el Código de la Imagen:</h4>
                    <table>
                        <tbody><tr>
                            <td>
                                <canvas id="captcha">
                                </canvas></td>
                        </tr>
                            <tr>
                                <td>
                                    <input ref={txtValor} autoFocus type="text" className="input-group" id="txtInput" onKeyUp={handleInputChange} />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <input type="button" id="refresh" className="btn btn-success" defaultValue="actualizar" onClick={Captcha} />
                                </td>
                            </tr>
                        </tbody></table>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button ref={btnAcepta} onClick={props.onHideAcepta} className="btn btn-primary col-md-2"><i className="fa">  Aceptar</i></button>
                <button ref={btnCancela} onClick={props.onHideCancela} className="btn btn-danger col-md-2"><i className="fa"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export const AgregarProducto = (props) => {
    const btnSi = useRef();
    const btnNo = useRef();
    const [icono, setIcono] = useState('');
    const txtUnidad = useRef();
    const txtTotalPagar = useRef();
    const txtPercioUni = useRef();
    const txtProducto = useRef();
    const txtCantAlm = useRef();
    const txtCantPed = useRef();
    const [operacion, setOperacion] = useState()
    const [unidades, setUnidades] = useState()
    const [activate, setActivate] = useState(false);
    var op = require('../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');

    const onChange = (e) => {
        
        if(e.target.name === 'cantidad'){
            if(e.target.value !== ''){
                let monto = parseFloat(txtPercioUni.current.value.trim().replace(/\./g, '').replace(',', '.')) * parseInt(e.target.value)
                txtTotalPagar.current.value =   formatMoneda(monto.toString().replace(',', '').replace('.', ','), ',', '.', 2)

            } else{
                txtTotalPagar.current.value = parseFloat('0,00')
            }
        }
    }

    const agregar = () =>{
        props.onHideProdSi(txtProducto.current.value,txtPercioUni.current.value,txtCantPed.current.value,txtTotalPagar.current.value,icono,txtUnidad.current.value)
       
    }

    const onChangeValidar = () => {
        let sigue = true;
        if(txtUnidad.current.value === ''){
            txtUnidad.current.focus()
            sigue = false;
        } else if(txtCantPed.current.value === ''){
            txtCantPed.current.focus()
            sigue = false;
        }

        if(sigue){
            agregar()
        }
    }


    const seleccionarRegistros = () => {

        let campos = 'idunidadmedida, trim(descripcion) as descripcion';
        let nomtab = 'unidadmedida';
        let orden = 'idunidadmedida';
    
        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

       

        axios.get(endpoint, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then(function (response) {

            if (response.status === 200) {
                if (response.data.length > 0) {
                    setUnidades(response.data)
           
                }         
            }


        }).catch(function (error) {

            //setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
          

        }).finally(()=>{
            setActivate(false); 
        })

    }

    useEffect(() => {
        seleccionarRegistros()
       }, []);


   return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            animation={false}
            keyboard={false}
            show={props.mensaje.mostrar}
            onShow={() => { 
              
                setIcono(props.mensaje.icono)
                setOperacion(props.mensaje.operacion)
                txtTotalPagar.current.value = props.mensaje.operacion !== 1 ? props.mensaje.total : parseFloat('0,00')
                btnSi.current.focus();
        
                if(props.mensaje.operacion !== 1){
                    txtUnidad.current.value = props.mensaje.unidad
                }
            }}
               
               
        >
            <Modal.Body style={{ backgroundColor: "#ffffff" }} >
                <div className='row col-12 mx-auto'>
                    <div className='col-12 p-2'>
                        <h2 style={{ textAlign: 'center', fontWeight: 'bold', color: "#595959"}}>{props.mensaje.titulo}</h2>
                    </div>
                    <div className='col-12 p-2 text-center row mx-auto'>
                        <div className='col-md-5'>
                        <div  className="input-group input-group-sm mb-2 col-md-12 d-flex justify-content-center">
                                <input autoComplete='off'  style={{fontSize:'15px'}} type="text" ref={txtProducto} className="form-control rounded col-md-7 bg-transparent border-0 text-center" value={props.mensaje.texto} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                            </div> 
                            <img className='img-fluid' src={`${op.conexion}/imagen?img=${icono}`} />
                        </div>
                        <div className='col-md-7'>
                           
                           
                            <div className="input-group input-group-sm mb-2 col-md-12  d-flex justify-content-between mt-5">
                                <label style={{fontSize:'15px'}} className="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Unidad:</label>
                                <select name="nacionalidad" ref={txtUnidad}  style={{fontSize:'15px'}} className="form-select form-select-sm rounded col-md-5"  aria-label=".form-select-sm example" onChange={onChange} >
                                    <option value="">--</option>
                                    {unidades && unidades.map((item, index) => (
                                                <option key={index} value={item.idunidadmedida}  > {item.descripcion} </option>
                                            ))}
                                </select>

                            </div>
                            <div  className="input-group input-group-sm mb-2 col-md-12 d-flex justify-content-between">
                                <label style={{fontSize:'15px'}} className="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Precio Unitario:</label>
                                <input autoComplete='off'  style={{fontSize:'15px'}} type="text" ref={txtPercioUni} className="form-control rounded col-md-7 bg-transparent border-0 text-right" value={props.mensaje.precio} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                            </div>
                            <div  className="input-group input-group-sm mb-2 col-md-12 d-flex justify-content-between">
                                <label style={{fontSize:'15px'}} className="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Cantidad Disponible:</label>
                                <input autoComplete='off'  style={{fontSize:'15px'}} type="text" ref={txtCantAlm} className="form-control rounded col-md-7 bg-transparent border-0 text-right" value={props.mensaje.disponible} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                            </div>
                            <div  className="input-group input-group-sm mb-2 col-md-12 d-flex justify-content-between">
                                <label style={{fontSize:'15px'}} className="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Cantidad de Pedido:</label>
                                <input autoComplete='off'  style={{fontSize:'15px'}} type="text" ref={txtCantPed} className="form-control rounded col-md-4 text-right" aria-label="Sizing example input" defaultValue={props.mensaje ? props.mensaje.cantidad !== '' ? props.mensaje.cantidad : 1 : 1} aria-describedby="inputGroup-sizing-sm" name='cantidad' onChange={onChange} />

                            </div>
                            <div  className="input-group input-group-sm mb-2 col-md-12 d-flex justify-content-between">
                                <label style={{fontSize:'15px'}} className="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Total Pagar:</label>
                                <input autoComplete='off'  style={{fontSize:'15px'}} type="text" ref={txtTotalPagar} className="form-control rounded col-md-7 bg-transparent border-0 text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                            </div>
                            
                        </div>

                    </div>
                    <div className='row col-12 p-2 d-flex justify-content-center mx-auto mt-2'>
                        <button className='btn btn-sm rounded-pill btn-success col-md-2 mx-2' ref={btnSi} onClick={onChangeValidar}>Agregar</button>
                        <button className='btn btn-sm rounded-pill btn-danger col-md-2 mx-2' ref={btnNo} onClick={operacion === 1 || operacion === 3 ? props.onHideProdNo : agregar }>Cancelar</button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}


// WEBPACK FOOTER //
// ./src/components/mensajes.js